import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MenuHoursExpiredNotification from 'bento-ordering/base/components/MenuHoursExpiredNotification';

import { goToOrderSettings } from 'bento-ordering/cart/actions/orderSettings';
import { updateFulfillmentOptionsForCartLocation } from 'bento-ordering/locations/actions/locationFulfillmentOptions';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
class MenuHoursExpiredNotificationContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    onlineOrderingFulfillmentMethod: PropTypes.oneOf([
      fulfillmentOptions.PICKUP,
      fulfillmentOptions.DELIVERY,
      fulfillmentOptions.DINE_IN
    ])
  };

  handlePrimaryCta = async () => {
    const { dispatch } = this.props;
    await dispatch(updateFulfillmentOptionsForCartLocation());
    dispatch(goToOrderSettings());
  };

  render() {
    const { closeModal, onlineOrderingFulfillmentMethod } = this.props;

    return (
      <MenuHoursExpiredNotification
        handlePrimaryCta={this.handlePrimaryCta}
        closeModal={closeModal}
        onlineOrderingFulfillmentMethod={onlineOrderingFulfillmentMethod}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    onlineOrderingFulfillmentMethod:
      state.cart.online_ordering_fulfillment_method
  };
};

export default connect(mapStateToProps)(MenuHoursExpiredNotificationContainer);
